import { createFileRoute } from '@tanstack/react-router'

import { PortalProjects } from '@/components/portal/portal-projects'

export const Route = createFileRoute('/portal/projets/')({
  component: PortalProjects,
})
